import styled from "styled-components";

export const UploadFilePageStyles = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

  h2 {
    color: #111;
    font-family: "Open Sans";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 24px;
  }
`;

export const WraperInputFile = styled.div`
  background: #f7f7f7;
  padding: 45px 46px;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;

export const FileStyle = styled.div`
  font-family: "Open Sans";
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    display: block;
  }

  p {
    color: #111;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }

  span {
    cursor: pointer;
  }
`;

export const WraperFiles = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 36px;
`;

export const WrapperButton = styled.div`
  display: flex;
  justify-content: end;
  gap: 16px;
`;
